import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DashboardService } from '../../../../../service/events/dashboard.service';
import { TareasApiService } from '../../../../../service/api/tareas-api.service';
import { FincasApiService } from '../../../../../service/api/fincas-api.service';
import { ClientesApiService } from '../../../../../service/api/clientes-api.service';
import { TrabajadoresApiService } from '../../../../../service/api/trabajadores-api.service';
import { TareaLimpiezaGeneralModel } from '../../../../../models/tareas/tarea-limpieza-general.model';
import { MtoReactiveFormComponent } from '../../mto-reactive/mto-reactive-form.component';
import { TareasMtoLimpiezaGeneralFormDefinition } from './form-control/form-definition';

@Component({
    selector: 'app-tareas-mto-limpieza-general-form',
    standalone: false,
    templateUrl: './tareas-mto-limpieza-general-form.component.html',
    styleUrls: ['./tareas-mto-limpieza-general-form.component.scss'],
})
export class TareasMtoLimpiezaGeneralFormComponent extends MtoReactiveFormComponent<
    TareaLimpiezaGeneralModel,
    TareasMtoLimpiezaGeneralFormDefinition
> {
    constructor(
        route: ActivatedRoute,
        dashboard: DashboardService,
        fincasApi: FincasApiService,
        clientesApi: ClientesApiService,
        trabajadoresApi: TrabajadoresApiService,
        tareasApi: TareasApiService,
        router: Router,
    ) {
        super(
            route,
            router,
            dashboard,
            fincasApi,
            clientesApi,
            trabajadoresApi,
            tareasApi.mtoLimpiezaGeneral.PUT,
            tareasApi.mtoLimpiezaGeneral.POST,
            tareasApi.mtoLimpiezaGeneral.GET,
            'limpieza',
            'Actualizar Tarea Limpieza General',
            'Realizar Tarea Limpieza General',
            'Duplicar Tarea Limpieza General',
            {
                loadingLabel: 'Cargando datos del formulario de limpieza general...',
                errorContext: 'limpieza general',
            },
        );
    }

    protected createFormDefinition(): TareasMtoLimpiezaGeneralFormDefinition {
        return new TareasMtoLimpiezaGeneralFormDefinition(this.getType(), this.model);
    }
}
